import { render, staticRenderFns } from "./properties-footer.vue?vue&type=template&id=2adcbd21&scoped=true"
import script from "./properties-footer.vue?vue&type=script&lang=js"
export * from "./properties-footer.vue?vue&type=script&lang=js"
import style0 from "./properties-footer.vue?vue&type=style&index=0&id=2adcbd21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adcbd21",
  null
  
)

export default component.exports